import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=bff254aa&scoped=true&"
import script from "./RegisterModal.vue?vue&type=script&lang=js&"
export * from "./RegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModal.vue?vue&type=style&index=0&id=bff254aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff254aa",
  null
  
)

export default component.exports